import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { UserModel } from "@bt/core/models";
import { UserService } from "@bt/core/services";
import { Router } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { NotifierService } from 'angular-notifier';
import { UsersInviteModel } from "@bt/core/models/usersInviteModel.model";
import { BaseComponent } from "@bt/core/base";
import {faArrowLeft,faArrowRight} from "@fortawesome/free-solid-svg-icons"

@Component({
  selector: "app-create-user",
  templateUrl: "./create-user.component.html",
  styleUrls: ["./create-user.component.scss"]
})
export class CreateUserComponent extends BaseComponent implements OnInit, OnDestroy {
  // public newUser: UserModel;
  @ViewChild('customNotification') customNotificationTmpl;

  faArrowLeft=faArrowLeft;
  faArrowRight=faArrowRight;

  public employeesform: FormGroup;
  public isSubmitted: boolean = false;
  private notifier: NotifierService;
  private usersInviteModel: UsersInviteModel;
  public errors: string[];

  constructor(
    private userService: UserService,
    private fb: FormBuilder,
    private router: Router,
    notifierService: NotifierService
  ) {

    super();
    this.notifier = notifierService;

  }

  ngOnInit(): void {
    this.usersInviteModel = new UsersInviteModel();
    this.usersInviteModel.emails = [];

    this.employeesform = this.fb.group({
      user1: ["", [Validators.pattern(this.emailPattern)]],
      user2: ["", [Validators.pattern(this.emailPattern)]],
      user3: ["", [Validators.pattern(this.emailPattern)]],
      greeting: ["Добро пожаловать в обучающую программу!"]
    });
  }
  ngOnDestroy(): void {
    this.employeesform.reset();
  }

  get user1() { return this.employeesform.get('user1'); }
  get user2() { return this.employeesform.get('user2'); }
  get user3() { return this.employeesform.get('user3'); }
  get greeting() { return this.employeesform.get('greeting'); }

  public validateForm(): boolean {

    if (this.user1.value.length == 0 && this.user2.value.length == 0 && this.user3.value.length == 0) {
      this.notifier.notify("error", "Все поля пустые");
      return false;
    }

    if (this.user1.invalid || this.user2.invalid || this.user3.invalid) {
      this.notifier.notify("error", "Форма заполнена неправильно");
      return false;
    }

    if (this.user1.value == this.user2.value && this.user2.value.length > 0
      || this.user1.value == this.user3.value && this.user3.value.length > 0
      || this.user2.value == this.user3.value && this.user3.value.length > 0) {
      this.notifier.notify("error", "Адреса пользователей должны быть уникальными");
      return false;

    }

    return true;
  }

  public createUsers() {

    var t = this;
    this.isSubmitted = true;
    t.setLoading(true);
    if (!this.validateForm()) {
      t.setLoading(false);
      return;
    }

    if (this.employeesform.value.user1 != '') {
      this.usersInviteModel.emails.push(this.employeesform.value.user1);
    }
    if (this.employeesform.value.user2 != '') {
      this.usersInviteModel.emails.push(this.employeesform.value.user2);
    }
    if (this.employeesform.value.user3 != '') {
      this.usersInviteModel.emails.push(this.employeesform.value.user3);
    }

    this.usersInviteModel.greeting = this.employeesform.value.greeting;

    this.userService.createUsers(this.usersInviteModel)
      .then((resp) => {
        t.setLoading(false);
        if (resp.data === true) {
          this.router.navigateByUrl("app/all-users");
          this.showNotification('success', 'Приглашение отправлено на e-mail');
        }
        else {
          resp.errorMsgs.forEach(msg => {
            this.showNotification('error', msg);
            this.usersInviteModel = new UsersInviteModel();
            this.usersInviteModel.emails = [];
          });

          console.error("Error #" + resp.errorCode + ": " + resp.errorMsgs);
        }
      })

      .catch((error) => {
        if (error.error && error.error.errorMsgs) {
          error.error.errorMsgs.forEach(msg => {
            this.showNotification('error', msg);
          });
          this.usersInviteModel = new UsersInviteModel();
          this.usersInviteModel.emails = [];
          t.setLoading(false);
        }
      });
  }

  public resetForm() {
    this.employeesform.reset();
  }

  public backToAllUser() {
    this.router.navigateByUrl("app/all-users");
  }

  public showNotification(type: string, message: string): void {
    if (!this.user1.invalid) {
      this.notifier.notify(type, message);
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/admin/create-user/create-user.component.ts